import $ from 'jquery'
import storeEngine from 'store/src/store-engine'
import Analytics from '../../../modules/Analytics'

const storages = [
  require('store/storages/cookieStorage')
]
const store = storeEngine.createStore(storages)

const wishlist = store.get('wishlist') || []
let ready = false

function update() {
  if (ready) {
    $('.js-wishlist-counter').text( wishlist.length )
  }
}

function save() {
  store.set('wishlist', wishlist)
}

const wishlistClickHandler = function(e){
  e.preventDefault()
  e.stopPropagation()

  $(this).toggleClass('is-active')

  const product_id = $(this).data('product-id')

  toggle_wishlist( product_id )

  update()
}

$(() => {
  ready = true

  update()

  $('.js-wishlist-counter').removeClass('d-none')

  wishlist.forEach(product_id => {
    $(`.js-add-to-wishlist[data-product-id=${product_id}]`).addClass('is-active')
  })

  $('.js-add-to-wishlist').click(wishlistClickHandler)
})

const updateWishlistIconsFor$Element = function( $elem ) {
  wishlist.forEach(product_id => {
    $elem.find(`.js-add-to-wishlist[data-product-id=${product_id}]`).addClass('is-active')
  })

  $elem.find(`.js-add-to-wishlist`).click(wishlistClickHandler)
}

const get_idx_wishlist = function(product_id) {
  return wishlist.findIndex(p_id => p_id == product_id)
}

const toggle_wishlist = function(product_id) {
  const idx = get_idx_wishlist(product_id)

  if (idx > -1) {
    wishlist.splice(idx, 1)
  } else {
    wishlist.push(product_id)

    Analytics.wishlist(product_id)
  }

  save()
}

export {updateWishlistIconsFor$Element, get_idx_wishlist, toggle_wishlist}
